const useGetMetadataId = () => {
  const url =
    process.env.NODE_ENV !== 'production'
      ? 'https://master.dev.24heures.ch/archie-miniserie-sur-miniserie-902953783635'
      : window.location.href
    
  // To get the id from the URL, we need to match a digit
  // that is at least 8 characters long
  const idMatch = url.match(/\d{8,}/g)

  if (idMatch) {
    return idMatch[0]
  } else {
    console.warn('No id found in URL')
    return undefined
  }
}

export default useGetMetadataId
